import { clientSide } from './dom.js';

// Used to wrap and standardize debugging logs
// Only prints if window.Bricks.debug is true
const debugLog = function (message) {
  if (clientSide && window.Bricks?.debug) {
    console.group(`Bricks Debug | ${message}`);
    for (var _len = arguments.length, optionalParams = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      optionalParams[_key - 1] = arguments[_key];
    }
    optionalParams && console.log(...optionalParams);
    console.groupEnd();
  }
};

export { debugLog };
